
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/liability-insurance/professional-indemnity-insurance",
      function () {
        return require("private-next-pages/products/liability-insurance/professional-indemnity-insurance/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/liability-insurance/professional-indemnity-insurance"])
      });
    }
  